import { TableV2, SwapVerticalIcon } from '@medeloop/medeloop-components-library';
import { useEffect } from 'react';
import { ConceptCode } from './types';
import { useTableSort } from './hooks/use-table-sort';

interface SortableCodeTableProps {
  data: ConceptCode[];
  selectedRows: string[];
  onRowSelect: (selectedCodes: string[]) => void;
  className?: string;
}

const SortableCodeTable: React.FC<SortableCodeTableProps> = ({
  data,
  selectedRows,
  onRowSelect,
  className,
}) => {
  const { sortedData, setSortedData, sortByKey } = useTableSort(data);

  useEffect(() => {
    setSortedData(data);
  }, [data]);

  const tableHeaders = [
    {
      key: 'concept_id',
      label: 'Code',
      id: 'concept_id',
      sortable: true,
      onClick: () => sortByKey('concept_id'),
    },
    {
      key: 'concept_name',
      label: 'Concept Name',
      id: 'concept_name',
      sortable: true,
      onClick: () => sortByKey('concept_name'),
    },
    {
      key: 'concept_count',
      label: 'N',
      id: 'concept_count',
      sortable: true,
      onClick: () => sortByKey('concept_count'),
    },
    {
      key: 'relevance',
      label: 'Relevance',
      id: 'relevance',
      sortable: true,
      onClick: () => sortByKey('relevance'),
    },
  ];

  return (
    <TableV2
      sortIcon={<SwapVerticalIcon className="fill-white" />}
      headers={tableHeaders}
      data={sortedData}
      className={className}
      selectable={true}
      selectedRows={selectedRows}
      onRowSelect={onRowSelect}
    />
  );
};

export default SortableCodeTable;
